import { render } from "./PayWithCard.vue?vue&type=template&id=620d9372"
import script from "./PayWithCard.vue?vue&type=script&lang=js"
export * from "./PayWithCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__